/* djusie-carousel.js (Build #210, 2026-08-27)

   Tuotenostojen karuselli: nuolet desktopissa, natiivi swipe mobiilissa.
   Jyrin pyyntö: "koko sivun leveys ja karuselli desktopissa ja mobiilissa".

   Periaate: vieritys on natiivi CSS overflow-x + scroll-snap, joten se toimii
   ILMAN JavaScriptiä (swipe, näppäimistö, trackpad). JS lisää vain nuolinapit
   ja piilottaa ne kun ei ole vieritettävää → progressive enhancement.

   Käyttö: <div class="djusie-carousel" data-djusie-carousel> ... </div>
   Nuolet luodaan JS:llä, jotta ne eivät näy jos JS on pois päältä eikä
   markkupissa ole toimimattomia nappeja.
*/
(function () {
  'use strict';

  var LABEL_PREV = 'Previous';
  var LABEL_NEXT = 'Next';

  function svgArrow(dir) {
    var d = dir === 'prev' ? 'M15 4 L7 12 L15 20' : 'M9 4 L17 12 L9 20';
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
           '<path d="' + d + '" fill="none" stroke="currentColor" ' +
           'stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function init(root) {
    if (root.dataset.djusieCarouselReady === '1') return;

    var track = root.querySelector('[data-djusie-carousel-track]');
    if (!track) return;

    // Lokalisoidut nuolitekstit, jos section on ne antanut
    var prevLabel = root.dataset.labelPrev || LABEL_PREV;
    var nextLabel = root.dataset.labelNext || LABEL_NEXT;

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'djusie-carousel__arrow djusie-carousel__arrow--prev';
    prev.setAttribute('aria-label', prevLabel);
    prev.innerHTML = svgArrow('prev');

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'djusie-carousel__arrow djusie-carousel__arrow--next';
    next.setAttribute('aria-label', nextLabel);
    next.innerHTML = svgArrow('next');

    root.appendChild(prev);
    root.appendChild(next);

    function step() {
      var item = track.querySelector(':scope > *');
      if (!item) return track.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function scrollBy(dir) {
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { scrollBy(-1); });
    next.addEventListener('click', function () { scrollBy(1); });

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;
      // 2px toleranssi: subpikselit tekevät tarkasta vertailusta epäluotettavan
      var scrollable = max > 2;
      root.classList.toggle('djusie-carousel--has-overflow', scrollable);
      prev.hidden = !scrollable || x <= 2;
      next.hidden = !scrollable || x >= max - 2;
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(track);
    }
    update();

    root.dataset.djusieCarouselReady = '1';
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-djusie-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme Editor: sectionin uudelleenlataus
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
